<h2 mat-dialog-title>{{ 'selectLocalFolderPathDialogComponent.dialogTitle' | translate }}</h2>
<div class="container">
  <p>{{'selectLocalFolderPathDialogComponent.message1' | translate }}<br>
    {{ 'selectLocalFolderPathDialogComponent.message2' | translate }}</p>

  <div class="form-div" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
    <mat-form-field fxFlex>
      <mat-label>{{ 'selectLocalFolderPathDialogComponent.destinationFolder' | translate }}</mat-label>
      <input matInput [formControl]="destFolderPathControl" required readonly>
    </mat-form-field>
    <button class="select-folder-btn" mat-raised-button type="button" (click)="getFolderPath();">
      {{ 'dataUploadDialog.selectFolder' | translate }}
    </button>
  </div>
</div>

<div class="container" fxLayout="row" fxLayoutAlign="center center" position="fixed">
  <mat-dialog-actions>
    <button mat-button mat-dialog-close color="primary">{{'selectLocalFolderPathDialogComponent.cancel' | translate}}</button>
    <button mat-raised-button [disabled]="destFolderPathControl.invalid" color="primary" (click)="transfer()">
      {{'selectLocalFolderPathDialogComponent.selectDestination' | translate}}
    </button>
  </mat-dialog-actions>
</div>
